import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const breakpoints = {
  mobile: '600px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1200px'
};

export const ContainerSignIn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 10px;
  }
`;

export const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 15% 50%, rgba(255,255,255,0.1) 0%, transparent 20%),
                    radial-gradient(circle at 85% 30%, rgba(255,255,255,0.05) 0%, transparent 20%);
`;

export const Card = styled.div`
  width: 100%;
  max-width: 450px;
  z-index: 1;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 100%;
    padding: 0 10px;
  }

  @media (min-width: ${breakpoints.mobile}) and (max-width: ${breakpoints.tablet}) {
    max-width: 400px;
  }
`;

export const StyledPaper = styled(Paper)`
  padding: 40px 35px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);

  @media (max-width: ${breakpoints.mobile}) {
    padding: 30px 20px;
    border-radius: 15px;
  }

  @media (min-width: ${breakpoints.tablet}) {
    padding: 50px 40px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 25px;

  img {
    object-fit: contain;
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 20px;
  }
`;

export const TitleSignIn = styled.h2`
  color: #333;
  text-align: center;
  margin-bottom: 30px;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1.3;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.4rem;
    margin-bottom: 25px;
  }

  @media (min-width: ${breakpoints.tablet}) {
    font-size: 2rem;
  }
`;

export const Form = styled.form`
  width: 100%;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 15px;

  .MuiTextField-root {
    background: white;
    
    .MuiOutlinedInput-root {
      border-radius: 10px;
      
      @media (max-width: ${breakpoints.mobile}) {
        border-radius: 8px;
      }
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 12px;
  }
`;

export const ErrorText = styled.p`
  color: #f44336;
  font-size: 0.875rem;
  margin-top: 5px;
  min-height: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.75rem;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  justify-content: center;
  margin-top: 30px;
  width: 100%;

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 25px;
  }
`;

export const FooterText = styled.p`
  text-align: center;
  margin-top: 40px;
  color: #666;
  font-size: 0.875rem;
  opacity: 0.8;

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 30px;
    font-size: 0.75rem;
  }

  @media (min-width: ${breakpoints.tablet}) {
    margin-top: 50px;
    font-size: 0.9rem;
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
`;

export const LoadingContent = styled.div`
  text-align: center;
  padding: 40px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  max-width: 90%;
  
  @media (max-width: ${breakpoints.mobile}) {
    padding: 30px 20px;
    border-radius: 15px;
  }
`;

export const LoadingText = styled.h3`
  color: white;
  margin-top: 20px;
  font-size: 1.5rem;
  font-weight: 600;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.2rem;
    margin-top: 15px;
  }
`;

export const SubText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  margin-top: 10px;
  font-size: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.875rem;
  }
`;